import Config from 'config/settings';
import { Module } from 'core/Module';

export class LazyLoadImage extends Module {
	public config = {
		ratio: 'square',
		fade: true,
		fadeTime: 0.25
	};

	public create(): void {
		if (this.config.fade) {
			let image: HTMLImageElement = this.$container.querySelector('img');

			if (!image) {
				return;
			}

			let loaded = image.complete && image.naturalHeight !== 0;

			if (loaded) {
				return;
			}

			gsap.TweenMax.set(image, { autoAlpha: 0 });

			let handleLoad = function (e) {
				image.removeEventListener('load', handleLoad.bind(this));
				gsap.TweenMax.to(image, this.config.fadeTime, { autoAlpha: 1, ease: Config.linearEase });
				this.destroy();
			};

			image.addEventListener('load', handleLoad.bind(this));
		}
	}
}
